import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth' // 验权
import versionTood from '@/utils/versionUpdate.js'
import i18n from "@/lang";
import {clearScrollPositions, saveScrollPosition,} from '@/utils/pageNavigation'
import { updateBreadcrumbParent } from "@/utils/breadcrumb";
import { applyLatestLanguage } from '@/lang'
import { syncRouteTitles } from "@/utils/settingRouteLang";

const whiteList = ['/login', '/register', '/shopApply','/shopApplyCountry' ,'/entryByIndividual', '/entryByCompany', '/forgotPassword'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  // if(process.env.NODE_ENV === "production") {
  //   versionTood.isNewVersion();
  // }
  const languageSync = applyLatestLanguage()
  if (languageSync.changed) {
    syncRouteTitles(languageSync.previousLanguage, languageSync.language)
  }

  if (to.path === '/login') {
    clearScrollPositions()
    store.commit('RESET_PAGE_CACHE')
  }

  if (from.name && from.meta && from.meta.keepAlive) {
    saveScrollPosition(from.name)
  }
  updateBreadcrumbParent(to, from)

  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({path: '/'})
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else if (whiteList.includes(to.path)) {
      next()
    }else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus = res.data.permission.menus;
          let username = res.data.username;
          store.dispatch('GenerateRoutes', {menus, username}).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({...to, replace: true})
            NProgress.done()
          })
        }).catch((err) => {
          store.dispatch('LogOut').then(() => {
            Message.error(err || i18n.t('ums.verificationFailed'))
            next({path: '/login'})
          })
          NProgress.done()
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('register')!== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js